import { generateFormFieldComponents } from "../createPage/cratePageGeneror";
import { getFilterDrawer } from "../listPage/filterDrawer";

export function getFilterForm(searchableFields:any):any{
  const applyConfguration = buildDynamicSetValueMappings(
    searchableFields,
    "APPLY"
  );
  const resetConfguration = buildDynamicSetValueMappings(
    searchableFields,
    "RESET"
  );
    const updatedFields = addSuffixToFieldName(searchableFields, "_FILTER");
    const searchModal = createSearchForm(
    updatedFields,
    applyConfguration,
    resetConfguration
  );
return searchModal;
}
export function addSuffixToFieldName(fields: any[], suffix: string): any[] {
  return fields.map((field) => ({
    ...field,
    name: `${field.name}${suffix}`,
  }));
}
export function createSearchForm(
  updatedFields: any,
  applyConfguration: any,
  resetConfguration: any
): any {
  const fieldComponents = generateFormFieldComponents(
    updatedFields,
    "EDIT",
    "RENDER",
    [],
    true
  );

  const searchForm = getFilterDrawer(
    fieldComponents,
    applyConfguration,
    resetConfguration
  );
  //console.log("Search Form " , searchForm);
  return searchForm;
}

export function buildDynamicSetValueMappings(
  fields: any[],
  mode: "APPLY" | "RESET"
): any[] {
  return fields.map((field) => ({
    isSetValueDynamic: mode === "APPLY",
    mappingField: field.name,
    valueToSet: mode === "APPLY" ? `${field.name}_FILTER` : "",
  }));
}